/**
 * Key code constants
 */

const KeyCode = {
    ESC: 'Escape',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight'
};

export {KeyCode};
